// import React, {useState} from 'react'
// import './Loginandregister.css'
// import {NavLink, useLocation, useNavigate} from "react-router-dom";
// import { validateEmail } from '../Utils/Validation';
// import { signInWithEmailAndPassword } from 'firebase/auth';
// import { auth } from "../firebase/firebase";
// import Loading from '../Loader/Loadering';

// export default function Login() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [isEmailValid, setIsEmailValid] = useState(true);
//   const [emailError, setEmailError] = useState('');
//   const [passwordError, setPasswordError] = useState('');
//   const [loading, setLoading] = useState(false); // Loader state

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { state } = location;
//   const from = state?.from || '/';

//   // const handleInputEmailChange = (event) => {
//   //   const value = event.target.value;
//   //   setEmail(value);
//   //   const emailPattern = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
//   //   setIsEmailValid(emailPattern.test(value) || value === '');
//   // };
//   const handleEmailChange = (event) => {
//           validateEmail(event.target.value, setEmail, setIsEmailValid);
//         };

//   const handleInputPasswordChange = (event) => {
//     const value = event.target.value;
//     setPassword(value);
//     setPasswordError(''); // Reset password error when user modifies the password
//   };

//   const handleLogin = async (event) => {
//     event.preventDefault();
//     setEmailError('');
//     setPasswordError('');
//     setLoading(true); // Show Loader
  
//     if (!email || !password) {
//       if (!email) setEmailError('Please enter your email.');
//       if (!password) setPasswordError('Please enter your password.');
//       setLoading(false); // Hide Loader if fields are empty
//       return;
//     }
  
//     if (!isEmailValid) {
//       setEmailError('Email wrong formatting');
//       setLoading(false); // Hide Loader
//       return;
//     }
  
//     try {
//       const userCredential = await signInWithEmailAndPassword(auth, email, password);
//       // alert('Login Successfully.');
//       handleSuccessfulLogin(); 
//     } catch (error) {
//       setLoading(false); // Pehle loader hatao
//       setTimeout(() => {
//         if (error.code === 'auth/invalid-credential') {
//               alert(`Invalid credentials. ${error.message}`);
//             } else {
//               // Generic error handling for other types of errors
//               alert(`Invalid credentials. ${error.message}`);
//             }
//       }, 50); // Alert ko ek microtask delay dene ke liye setTimeout(,0) use kiya
//     } finally {
//       setLoading(false); // Hide Loader after login attempt
//     }
//   };

//   const handleSuccessfulLogin = () => {
//     // Check if the redirect state exists, and use it; otherwise, use a default path
//     // const from = location.state?.from || '/defaultpath';
//     navigate(from); // Redirect user after successful login
//   };


//   return (
//     <>
//       <div className='Background'>
//         <div className='loginimageside'>
//         </div>
//         <div className='auth-formside'>
          
//           <form onSubmit={handleLogin}>
//             <h2>Login.</h2>
//             <label> Email address </label>
//             <div class="wrapper">
//               <i class="ri-mail-line"></i>
//               <input 
//               type='text'  
//               name='email' 
//               placeholder='john123@gmail.com' 
//               value={email} 
//               onChange={handleEmailChange} 
//               required/>
//               {emailError && (
//                 <div style={{ color: 'red', fontSize: '15px' }}>
//                   {emailError}
//                 </div>
//               )}
//             </div>
            
//             <label> Password </label>
//             <div class="wrapper">
//             <i class="ri-lock-line"></i>
//             <input 
//               type='password' 
//               name='password' 
//               placeholder='your password' 
//               onChange={handleInputPasswordChange}
//               required
//             />
//             {passwordError && (
//                 <div style={{ color: 'red', fontSize: '15px' }}>
//                   {passwordError}
//                 </div>
//               )}
//             </div>
//             <span style={{display:'flex', justifyContent:'end',marginTop:'10px'}}>
//             <NavLink to="/forgotpassword" className='forgot-navlink' >Forgot Password</NavLink>
//             </span>
//             {/* {loading ? <Loading /> :<button type="submit">Login</button>} */}
//             <button type="submit" disabled={loading}>
//              {loading && <Loading /> }
//              Login
//             </button>

//             <p>Don't have an account? <NavLink to="/register" className='navlink'>Register</NavLink></p>
//           </form>
          
//         </div>
//       </div>
//     </>
//   )
// }

import React, { useState } from 'react';
import './Authentication.css'; // Make sure to import the new CSS file
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { validateEmail } from '../Utils/Validation';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from "../firebase/firebase";
import Loading from '../Loader/Loadering';
import SocialLogin from './SocialLogin'; // Import the new SocialLogin component
import InputField from './InputField'; // Import the new InputField component
import { motion } from "framer-motion";

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loading, setLoading] = useState(false); // Loader state

  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const from = state?.from || '/';

  const handleEmailChange = (event) => {
    validateEmail(event.target.value, setEmail, setIsEmailValid);
  };

  const handleInputPasswordChange = (event) => {
    const value = event.target.value;
    setPassword(value);
    setPasswordError(''); // Reset password error when user modifies the password
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setEmailError('');
    setPasswordError('');
    setLoading(true); // Show Loader

    if (!email || !password) {
      if (!email) setEmailError('Please enter your email.');
      if (!password) setPasswordError('Please enter your password.');
      setLoading(false); // Hide Loader if fields are empty
      return;
    }

    if (!isEmailValid) {
      setEmailError('Email wrong formatting');
      setLoading(false); // Hide Loader
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      handleSuccessfulLogin();
    } catch (error) {
      setLoading(false); // Hide Loader first
      setTimeout(() => {
        if (error.code === 'auth/invalid-credential') {
          alert(`Invalid credentials. ${error.message}`);
        } else {
          // Generic error handling for other types of errors
          alert(`Invalid credentials. ${error.message}`);
        }
      }, 50); // Delay the alert to ensure the loader is hidden
    } finally {
      setLoading(false); // Hide Loader after login attempt
    }
  };

  const handleSuccessfulLogin = () => {
    navigate(from); // Redirect user after successful login
  };

  return (
    <div className="auth-container">
      <motion.div
        className="login-container"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <SocialLogin />
        <h2 className="form-title">Log in</h2>
        <p className="separator"><span>or</span></p>
        <form onSubmit={handleLogin} className="login-form">
          <InputField
            type="email"
            placeholder="Email address"
            icon="mail"
            value={email}
            onChange={handleEmailChange}
          />
          {emailError && (
            <div style={{ color: 'red', fontSize: '15px' }}>
              {emailError}
            </div>
          )}
          <InputField
            type="password"
            placeholder="Password"
            icon="lock"
            value={password}
            onChange={handleInputPasswordChange}
          />
          {passwordError && (
            <div style={{ color: 'red', fontSize: '15px' }}>
              {passwordError}
            </div>
          )}
          <NavLink to="/forgotpassword" className="forgot-password-link">Forgot password?</NavLink>
          <motion.button 
            type="submit" 
            className="login-button" 
            disabled={loading}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.9 }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
          >
            {loading && <Loading />}
            Login
          </motion.button>
        </form>
        <p className="signup-prompt">
          Don't have an account? <NavLink to="/register" className="signup-link">Sign up</NavLink>
        </p>
      </motion.div>
    </div>
  );
}